import PageBackBar from "@/components/PageBackBar";
import Location from "@/components/Location";
import PayBlock from "@/components/PayBlock";
import { useSite } from "@/Layout";

export default function VisitPage() {
  const { config } = useSite();
  return (
    <div data-testid="visit-page">
      <PageBackBar testId="visit-back-bar" />
      <Location config={config} />
      <PayBlock config={config} />
    </div>
  );
}
